import React from "react";
import styled from "styled-components";

const UpdateDate = styled.span`
    display: block;
    font-size: 1rem;
`;

const AppUpdateDate = ({date}) => (
    <UpdateDate title={`This version of the app was released on ${date.toLocaleDateString()}`}>
        Last updated: {date.toLocaleDateString()}
    </UpdateDate>
);

export default AppUpdateDate;